exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selectPhoneNumber .vue-tel-input {\n  height: 50px;\n  /* margin-bottom: 28px; */\n  width: 100%;\n  background: #ffffff;\n  border: 1px solid #e4e5e7;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n}\n.selectPhoneNumber .vti__dropdown {\n  background: #f7f7f8;\n  /* border: 1px solid #E4E5E7; */\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px 0px 0px 4px;\n}\n", ""]);

// exports
